import type { CurrentPageSectionType } from '@seek/libs-shared';
import {
  buildWriteAReviewURI,
  useAppContext,
  useConfig,
} from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { ButtonLink, IconEdit } from 'braid-design-system';
import type { AppConfig } from '../../../shared/config';
import { trackLinkEvents } from '../../../shared/tracking/candidateApp/trackLinkEvents';
import translations from './.vocab';

interface WriteReviewButtonProps {
  companyProfileName: string;
  origin: CurrentPageSectionType;
}

export function WriteReviewButton({
  companyProfileName,
  origin,
}: WriteReviewButtonProps) {
  const config = useConfig<AppConfig>();
  const { language, consolidated, environment } = config;

  const { t } = useTranslations(translations);
  const context = useAppContext();
  const { country } = useConfig();

  const trackWriteAReviewClicked = () => {
    trackLinkEvents.trackWriteAReviewButtonClicked({
      config,
      context,
      actionOrigin: origin,
    });
  };
  const handleWriteAReviewClicked = async () => {
    trackWriteAReviewClicked();
    await new Promise((resolve) => setTimeout(resolve, 500));
  };

  return (
    <ButtonLink
      onClick={() => {
        void handleWriteAReviewClicked();
      }}
      href={buildWriteAReviewURI({
        country,
        language,
        environment,
        consolidated,
        params: companyProfileName
          ? `cn=${encodeURIComponent(companyProfileName)}&tracking=company-profile`
          : undefined,
      })}
      variant="solid"
      rel="nofollow"
      size="standard"
      tone="formAccent"
      icon={<IconEdit />}
    >
      {t('Write a review')}
    </ButtonLink>
  );
}
